export const CAREPLAN_ADL_PBS_ID = '65e65524a07c451a8b4370fd'
export const CAREPLAN_ADL_EOL_ID = '5d6e3cffa97ed1e87f0c9fd2'
